import React, { ReactNode, useId } from 'react';
import { Tooltip } from 'primereact/tooltip';

interface Props {
  for: string;
  help?: string;
}

export const HelpToolTip: React.FC<Props> = (props: Props): ReactNode => {
  const id: string = useId().replaceAll(':', '');
  if(!props.help || props.help.length === 0) return null;

  const parsedFor = props.for?.replaceAll('.', '_');
  return (
    <div>
      <i
        id={`tt_${parsedFor}_${id}`}
        className={'pi pi-question-circle mx-2 cursor-pointer'}
        tabIndex={0}
        aria-label={props.help}
      />
      <Tooltip
        position={'top'}
        pt={{text: {className: 'surface-200 text-900 max-w-30rem'}}}
        event={'both'}
        target={`#tt_${parsedFor}_${id}`}
      >
        <div dangerouslySetInnerHTML={{__html: props.help}}></div>
      </Tooltip>
    </div>
  );
};
